import React from 'react';
import { MerchandiseCardProps } from '@honeycomb/ui';
import { TrBrandMerchandiseCard } from '../../MerchandiseCard';

export function MerchandiseCard(props: MerchandiseCardProps): React.JSX.Element {
    return <TrBrandMerchandiseCard {...props} />;
}
